import axios, { AxiosHeaders } from "axios";

const EpdServiceClient = axios.create({
  baseURL: import.meta.env.VITE_EPDSERVICE_BASEURL,
  timeout: 0,
});

EpdServiceClient.interceptors.request.use((request) => {
  return new Promise(function (resolve /*, reject*/) {
    const token = localStorage.getItem("carbon0.accessToken");

    if (token && request.headers) {
      request.headers = new AxiosHeaders({
        Accept: "application/json",
        "Content-Type": request.headers["Content-Type"] ?? "application/json",
        Authorization: `Bearer ${token}`,
      });
    }
    resolve(request);
  });
});

EpdServiceClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // handleAuthError();
    }
    return Promise.reject(error);
  }
);

const get = async (url: string) => {
  try {
    const response = await EpdServiceClient.get(url);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        console.error("Error response:", error.response.data);
        console.error("Error status:", error.response.status);
        console.error("Error headers:", error.response.headers);
      } else if (error.request) {
        console.error("Error request:", error.request);
      } else {
        console.error("Error message:", error.message);
      }
      console.error("Error config:", error.config);
    } else {
      console.error("Unexpected error:", error);
    }
    throw error;
  }
};

const post = async (url: string, data: any) => {
  try {
    const response = await EpdServiceClient.post(url, data);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        console.error("Error response:", error.response.data);
        console.error("Error status:", error.response.status);
        console.error("Error headers:", error.response.headers);

        // Return the error response data along with an error indicator
        return {
          error: true,
          status: error.response.status,
          data: error.response.data,
        };
      } else if (error.request) {
        console.error("Error request:", error.request);
      } else {
        console.error("Error message:", error.message);
      }
      console.error("Error config:", error.config);
    } else {
      console.error("Unexpected error:", error);
    }
    throw error;
  }
};

const put = async (url: string, data: any) => {
  try {
    const response = await EpdServiceClient.put(url, data);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        console.error("Error response:", error.response.data);
        console.error("Error status:", error.response.status);
        console.error("Error headers:", error.response.headers);

        // Return the error response data along with an error indicator
        return {
          error: true,
          status: error.response.status,
          data: error.response.data,
        };
      } else if (error.request) {
        console.error("Error request:", error.request);
      } else {
        console.error("Error message:", error.message);
      }
      console.error("Error config:", error.config);
    } else {
      console.error("Unexpected error:", error);
    }
    throw error;
  }
};

const delete_ = async (url: string) => {
  try {
    const response = await EpdServiceClient.delete(url);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        console.error("Error response:", error.response.data);
        console.error("Error status:", error.response.status);
        console.error("Error headers:", error.response.headers);

        // Return the error response data along with an error indicator
        return {
          error: true,
          status: error.response.status,
          data: error.response.data,
        };
      } else if (error.request) {
        console.error("Error request:", error.request);
      } else {
        console.error("Error message:", error.message);
      }
      console.error("Error config:", error.config);
    } else {
      console.error("Unexpected error:", error);
    }
    throw error;
  }
};

export default EpdServiceClient;

export { get, post, put, delete_ };
